export const CASE_STUDIES = [
  {
    slug: "luxury-residence-cat3-sewage-backflow",
    title: "Luxury Residence — Category 3 Sewage Backflow",
    location: "Edinburg, TX",
    industry: "Residential",
    summary:
      "Independent re-scoping of a contractor's Cat 2 designation revealed widespread sewage contamination requiring a full Cat 3 protocol.",
    sections: {
      background:
        "5,400 sq ft single-family residence. Owner-occupied. Initial contractor assigned Category 2 to a basement-level overflow event.",
      history:
        "Mainline backflow during a regional storm. Standing water present for ~36 hours before extraction.",
      inspection:
        "Visual inspection, moisture mapping, thermal imaging, and substrate sampling on Day 4 post-event.",
      moisture:
        "Elevated moisture across 1,180 sq ft of carpet pad, baseboards, and lower 24\" of drywall. Several wall cavities measured >25% MC.",
      thermal:
        "Thermal differential confirmed wicking up sheetrock to a continuous height of 22–28 inches.",
      sampling:
        "Surface total coliform and E. coli sampling collected on hard and porous substrates per IICRC S540 guidance.",
      lab:
        "AIHA-LAP laboratory confirmed coliform and E. coli presence on porous materials. Direct exam of bulk samples confirmed cellulose breakdown consistent with bacterial activity.",
      interpretation:
        "Findings reclassified the loss as Category 3 — sewage contamination requiring removal of all affected porous materials within the impact zone.",
      recommendations:
        "Full Cat 3 remediation protocol issued. Independent PRV scheduled prior to reconstruction.",
      protocol:
        "Containment, negative pressure, full PPE, removal of affected porous materials, antimicrobial application, and PRV against pre-defined clearance criteria.",
      lessons:
        "Initial categorization defines the entire scope. An independent assessment within 72 hours of the event prevents under-remediation and downstream health risk.",
    },
    related: ["category-3-water-explained", "iicrc-s520-explained"],
  },
  {
    slug: "k12-school-iaq-investigation",
    title: "K-12 School — Multi-Wing IAQ Investigation",
    location: "Hidalgo County, TX",
    industry: "Schools",
    summary:
      "Building-wide IAQ investigation following persistent occupant complaints in two wings — root cause traced to HVAC condensate management.",
    sections: {
      background:
        "Three-wing elementary campus, ~720 students. Persistent complaints of musty odors in Wings B and C.",
      history:
        "HVAC system age ~14 years. Two condensate pump failures in the prior 18 months in Wing C.",
      inspection:
        "Walkthrough, multi-parameter IAQ logging, HVAC plenum inspection, surface and air sampling.",
      moisture:
        "Elevated relative humidity (>65%) in Wing C return plenums during cooling cycles.",
      thermal:
        "Thermal imaging identified condensate accumulation in two AHU drain pans and insulation degradation downstream.",
      sampling:
        "Air spore counts at registers vs. outdoor controls; surface sampling at AHU coils.",
      lab:
        "Coil surface samples confirmed Cladosporium and Aspergillus/Penicillium colonization consistent with chronic biofilm.",
      interpretation:
        "Source was HVAC microbial amplification distributing throughout Wings B/C via ductwork.",
      recommendations:
        "Coil and drain pan cleaning, condensate management redesign, in-duct UV consideration, post-remediation re-sampling.",
      protocol:
        "NADCA ACR-compliant cleaning, AHU component replacement, and PRV via post-clean sampling.",
      lessons:
        "A small, persistent HVAC failure can drive months of building-wide IAQ complaints. Root-cause investigation is faster than chasing individual rooms.",
    },
    related: ["indoor-air-quality-for-schools"],
  },
  {
    slug: "commercial-office-post-leak-prv",
    title: "Class A Office Tower — Post-Remediation Verification",
    location: "South Texas",
    industry: "Commercial",
    summary:
      "Independent PRV for a remediation following a 6-floor riser failure. Two of six floors required additional remediation cycles.",
    sections: {
      background:
        "Class A office, ~340,000 RSF. Domestic water riser failure affected six floors over a weekend.",
      history:
        "Initial response by restoration contractor within 4 hours. Drying complete by Day 8. Remediation scope addressed visible affected materials.",
      inspection:
        "Independent PRV inspection of all six floors, plenums, and core walls.",
      moisture:
        "Two floors retained elevated moisture behind core walls not addressed in initial scope.",
      thermal:
        "Thermal anomalies confirmed by pin moisture meters at sub-surface depth.",
      sampling:
        "Air and surface sampling per pre-defined clearance criteria.",
      lab:
        "Two floors exceeded clearance criteria; four floors passed.",
      interpretation:
        "Initial scope under-addressed core wall cavities; remediation contractor returned to address.",
      recommendations:
        "Re-remediation of two floors; re-PRV performed and passed.",
      protocol:
        "Targeted demo of core wall sections, re-drying, antimicrobial treatment, re-sampling.",
      lessons:
        "Independent PRV is the safety net. A 4-hour response time does not guarantee a complete remediation.",
    },
    related: ["post-remediation-verification-guide", "iicrc-s520-explained"],
  },
];

export const CASE_STUDIES_INDEX = CASE_STUDIES.reduce((a, x) => ({ ...a, [x.slug]: x }), {});
